import angular from 'angular';
import uiRouter from 'angular-ui-router';
import {
  UProviderCardComponent,
  ULoadingHelper,
} from '@updater/angular-common';
import { RecommendedProvidersConfig } from './recommended-providers.config';
import { RecommendedProvidersComponent } from './recommended-providers.component';

export const RecommendedProvidersStepModule = angular
  .module('app.steps.recommended-providers', [
    uiRouter,
    ULoadingHelper.name,
    UProviderCardComponent.name,
  ])
  .config(RecommendedProvidersConfig)
  .component('updRecommendedProviders', RecommendedProvidersComponent);
